import labels from "app/labels";
import * as ko from "knockout";
import { httpErrorHandler } from "./httpErrorHandler";

class PortalHttpService {
  //

  post = async <T>(url: string, payload?: JQuery.PlainObject | string, shouldTranslate: boolean = true): Promise<T> => {
    try {
      return await $.post(url, payload);
    } catch (error) {
      console.error(error);
      throw httpErrorHandler.processError(error, shouldTranslate);
    }
  };

  get = async <T>(url: string, success_data?: JQuery.jqXHR.DoneCallback | JQuery.PlainObject | string): Promise<T> => {
    try {
      if (success_data) {
        return await $.get(url, success_data);
      } else {
        return await $.get(url);
      }
    } catch (error) {
      console.error(error);
      throw httpErrorHandler.processError(error);
    }
  };

  ajaxPost = <T>(url: string, formData?: FormData): Promise<T> => {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "POST",
        url: url,
        data: formData,
        contentType: false,
        processData: false,
        success: (data) => {
          resolve(data);
        },
        error: (error) => {
          console.error(error);
          reject(httpErrorHandler.processError(error));
        },
      });
    });
  };

  ajaxPostAsync = <T>(url, data): Promise<T> => {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "POST",
        url: url,
        data: data,
        success: resolve,
        error: reject,
      });
    });
  };
}

export const portalHttpService = new PortalHttpService();
